import { TabList } from 'components/ui/TabList/TabList';
import { TabContent } from 'components/ui/TabList/TabContent';
import { Loader } from '@trackman/web-shared-components';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { TeamLineup } from './TeamLineup/TeamLineup';
import { LineupManager } from 'models/setLineup/LineupManager';
import { Roster } from './Roster/Roster';
import { LoadingWrapper, PlaceholderText, TeamSetupPlaceholder, TeamSetupWrapper } from './TeamSetupStyles';
import LineupControls from './LineupControls/LineupControls';

export interface IProps {
  isLoading: boolean;
  lineupManager?: LineupManager;
  isPlaceholder: boolean;
  unavailablePlayerIds: string[];
  size: 'sm' | 'lg';
  placeholderText?: string;
  containerClass?: string;
}

export const TeamSetup: React.FC<IProps> = observer((props: IProps) => {
  const { isLoading, lineupManager, isPlaceholder, unavailablePlayerIds, size, placeholderText, containerClass } = props;

  const renderPlaceholder = (): JSX.Element => {
    return (
      <TeamSetupPlaceholder>
        {isLoading ? (
          <LoadingWrapper>
            loading...
            <Loader />
          </LoadingWrapper>
        ) : (
          <PlaceholderText>{placeholderText}</PlaceholderText>
        )}
      </TeamSetupPlaceholder>
    );
  };

  if (!lineupManager || isPlaceholder || isLoading) {
    return renderPlaceholder();
  }

  const getLabel = (): string => {
    if (lineupManager.isBattingPractice || lineupManager.isScrimmage) {
      return 'Lineup';
    }
    return `Lineup ${lineupManager.getFilledPositions().length}/${
      lineupManager.maxLineupEntries > lineupManager.lineup.length ? lineupManager.maxLineupEntries : lineupManager.lineup.length
    }`;
  };

  return (
    <TeamSetupWrapper>
      <TabList lineupManager={lineupManager} classNames={['team-setup']}>
        <TabContent label={getLabel()} name='lineup'>
          <TeamLineup lineupManager={lineupManager} unavailablePlayerIds={unavailablePlayerIds} containerClass={containerClass} />
        </TabContent>
        <TabContent label='Roster' name='roster'>
          <>{!lineupManager.isBattingPractice && <LineupControls lineupManager={lineupManager} />}</>
          <Roster lineupManager={lineupManager} unavailablePlayerIds={unavailablePlayerIds} size={size} />
        </TabContent>
      </TabList>
    </TeamSetupWrapper>
  );
});
